import {toaster} from './ui/toaster';

/** Copies a Drive entry's name to the clipboard and confirms it with a toast. */
export function copyFileName(name: string) {
    navigator.clipboard.writeText(name)
        .then(() => toaster.create({type: 'success', title: 'Fájlnév vágólapra másolva', description: name, duration: 1500}))
        .catch(() => toaster.create({type: 'error', title: 'A fájlnév másolása sikertelen'}));
}
